import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { DeviceFingerprintService } from '@infrastructure/device';
import { from, switchMap } from 'rxjs';

export const deviceFingerprintInterceptor: HttpInterceptorFn = (req, next) => {
  // Only add fingerprint for case opening endpoints
  if (req.method !== 'POST') {
    return next(req);
  }

  const url = req.url;
  const isOpenCaseRequest =
    /\/v1\/cases\/[^/]+\/open(?:\?|$)/.test(url) || /\/v1\/cases\/[^/]+\/open-multiple(?:\?|$)/.test(url);

  if (!isOpenCaseRequest) {
    return next(req);
  }

  if (req.headers.has('X-Device-Fingerprint')) {
    return next(req);
  }

  const deviceFingerprintService = inject(DeviceFingerprintService);

  return from(deviceFingerprintService.getFingerprint()).pipe(
    switchMap(fingerprint => {
      if (!fingerprint) {
        return next(req);
      }

      return next(
        req.clone({
          setHeaders: {
            'X-Device-Fingerprint': fingerprint,
          },
        })
      );
    })
  );
};
